import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL_V2;

console.log(backendUrl, "backendUrl");

const initialState = {
  isLoading: false,
  error: null,
  categories: [],
  category: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "catalogCategory",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    startCategoryLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.category = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishLoading(state) {
      state.isLoading = false;
      state.error = null;
    },

    getCategoriesSuccess(state, action) {
      state.isLoading = false;
      state.categories = action.payload.results || [];
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
      state.totalPages = action.payload.totalPages || 0;
      state.totalResults = action.payload.totalResults || 0;
    },

    getCategorySuccess(state, action) {
      state.isLoading = false;
      state.category = action.payload.result || action.payload;
    },
  },
});

export default slice.reducer;

export function getCatalogCategories({ franchiseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/category`, {
        params: {
          franchiseId,
          page,
          limit,
        },
      });

      dispatch(slice.actions.getCategoriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load catalog categories."));
    }
  };
}

export function createCatalogCategory({ franchiseId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${backendUrl}/franchise/category`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to create catalog category.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}

export function getCatalogCategory({ franchiseId, categoryId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startCategoryLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/category/${categoryId}`, {
        params: { franchiseId },
      });

      dispatch(slice.actions.getCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load catalog category."));
    }
  };
}

export function updateCatalogCategory({ franchiseId, categoryId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${backendUrl}/franchise/category/${categoryId}`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to update catalog category.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}
